import { useState } from 'react';
import StatusBadge from '../../components/common/StatusBadge';
import Pill from '../../components/common/Pill';
import CoreBadge from '../../components/common/CoreBadge';
import CheckboxCascata, { estadoSelecao } from '../../components/common/CheckboxCascata';

// Árvore Seção → Subseção → Requisito com checkbox de cascata: marcar um nó marca tudo dentro
// dele, mas cada requisito também pode ser marcado/desmarcado individualmente (o nó pai reflete
// o estado — cheio/parcial/vazio — a partir dos filhos, nunca guarda seleção própria).
export default function ArvoreSelecaoRequisitos({ arvore, selecionados, onChange, avaliacaoPorRequisito, expandirTudo }) {
  const [secoesAbertas, setSecoesAbertas] = useState(new Set());
  const [subsecoesAbertas, setSubsecoesAbertas] = useState(new Set());

  const toggleSecaoAberta = (id) =>
    setSecoesAbertas((s) => {
      const novo = new Set(s);
      novo.has(id) ? novo.delete(id) : novo.add(id);
      return novo;
    });

  const toggleSubsecaoAberta = (id) =>
    setSubsecoesAbertas((s) => {
      const novo = new Set(s);
      novo.has(id) ? novo.delete(id) : novo.add(id);
      return novo;
    });

  const estaMarcado = (id) => selecionados.has(id);

  const alternarGrupo = (ids) => {
    const estado = estadoSelecao(ids, estaMarcado);
    const novo = new Set(selecionados);
    if (estado === 'cheio') {
      ids.forEach((id) => novo.delete(id));
    } else {
      ids.forEach((id) => novo.add(id));
    }
    onChange(novo);
  };

  const alternarRequisito = (id) => {
    const novo = new Set(selecionados);
    novo.has(id) ? novo.delete(id) : novo.add(id);
    onChange(novo);
  };

  return (
    <div className="d-flex flex-column gap-2">
      {arvore.map(({ secao, subsecoes }) => {
        const idsSecao = subsecoes.flatMap((s) => s.requisitos.map((r) => r.id_requisito));
        const estadoSecao = estadoSelecao(idsSecao, estaMarcado);
        const aberta = secoesAbertas.has(secao.id_secao) || expandirTudo;

        return (
          <div key={secao.id_secao} className="card-soft" style={{ overflow: 'hidden' }}>
            <div className="d-flex align-items-center gap-3" style={{ padding: '14px 20px' }}>
              <CheckboxCascata estado={estadoSecao} onClick={() => alternarGrupo(idsSecao)} title="Marcar/desmarcar todos os requisitos desta Seção" />
              <button
                type="button"
                className="d-flex align-items-center gap-2 flex-grow-1 border-0 bg-transparent text-start"
                style={{ padding: 0, cursor: 'pointer' }}
                onClick={() => toggleSecaoAberta(secao.id_secao)}
              >
                <span className="ms" style={{ fontSize: 20, color: 'var(--am-cinza-texto-2)' }}>
                  {aberta ? 'expand_more' : 'chevron_right'}
                </span>
                <div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--am-tinta)' }}>
                    Seção {secao.numero} — {secao.nome}
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--am-cinza-texto-2)' }}>
                    {idsSecao.filter((id) => selecionados.has(id)).length} de {idsSecao.length} selecionado(s)
                  </div>
                </div>
              </button>
            </div>

            {aberta && (
              <div style={{ borderTop: '1px solid var(--am-borda-2)' }}>
                {subsecoes.map(({ sub, requisitos }) => {
                  const idsSub = requisitos.map((r) => r.id_requisito);
                  const estadoSub = estadoSelecao(idsSub, estaMarcado);
                  const subAberta = subsecoesAbertas.has(sub.id_subsecao) || expandirTudo;

                  return (
                    <div key={sub.id_subsecao} style={{ borderBottom: '1px solid var(--am-borda-2)' }}>
                      <div className="d-flex align-items-center gap-3" style={{ padding: '11px 20px 11px 44px' }}>
                        <CheckboxCascata estado={estadoSub} onClick={() => alternarGrupo(idsSub)} title="Marcar/desmarcar todos os requisitos desta Subseção" />
                        <button
                          type="button"
                          className="d-flex align-items-center gap-2 flex-grow-1 border-0 bg-transparent text-start"
                          style={{ padding: 0, cursor: 'pointer' }}
                          onClick={() => toggleSubsecaoAberta(sub.id_subsecao)}
                        >
                          <span className="ms" style={{ fontSize: 18, color: 'var(--am-cinza-texto-2)' }}>
                            {subAberta ? 'expand_more' : 'chevron_right'}
                          </span>
                          <div>
                            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--am-tinta)' }}>
                              {sub.numero} — {sub.nome}
                            </div>
                            <div style={{ fontSize: 12, color: 'var(--am-cinza-texto-2)' }}>
                              {idsSub.filter((id) => selecionados.has(id)).length} de {idsSub.length} selecionado(s)
                            </div>
                          </div>
                        </button>
                      </div>

                      {subAberta && (
                        <div className="d-flex flex-column gap-1" style={{ padding: '0 20px 12px 76px' }}>
                          {requisitos.map((r) => {
                            const marcado = selecionados.has(r.id_requisito);
                            const avaliacao = avaliacaoPorRequisito.get(r.id_requisito);
                            return (
                              <button
                                type="button"
                                key={r.id_requisito}
                                className="am-checkbox d-flex align-items-center gap-2"
                                style={{
                                  padding: '6px 8px',
                                  borderRadius: 8,
                                  background: marcado ? 'var(--am-amarelo-nevoa)' : 'transparent',
                                  width: '100%',
                                  textAlign: 'left',
                                }}
                                onClick={() => alternarRequisito(r.id_requisito)}
                              >
                                <span className={`am-checkbox__box${marcado ? ' is-checked' : ''}`}>
                                  {marcado && <span className="ms">check</span>}
                                </span>
                                <span className="d-flex align-items-center gap-1" style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>
                                  {r.codigo}
                                  {r.core && <CoreBadge />}
                                </span>
                                <span style={{ fontSize: 13, color: 'var(--am-cinza-texto-2)', flexGrow: 1 }} title={r.texto}>
                                  {r.texto}
                                </span>
                                {avaliacao ? <StatusBadge status={avaliacao.status} /> : <Pill tone="outline">Não avaliado</Pill>}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
